const anchorizeContents = require("../lib/faq/anchorize-contents");

anchorizeContents(document.getElementById("faq-content"));
